import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/system';
import Logo from 'app/components/Logo';

const Brand = ({ hover, children, mode }) => {
  const theme = useTheme();
  const isMdScreen = useMediaQuery(theme.breakpoints.down('md'));
  const smallLogo = !hover && !isMdScreen && mode !== 'full';
  return (
    <div className="site-logo">
      <div className="logo">
        <Logo dwf={true} small={smallLogo}/>
      </div>
      <div className={`md md-${mode}`}>
        {children || null}
      </div>
    </div>
  );
};

export default Brand;
